var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":true},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"text-center"},[_c('div',[_c('span',[_vm._v("请用微信扫描二维码关注公众号")])]),_c('img',{attrs:{"src":_vm.qrcode,"alt":"","width":"200"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }